import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Stack, Text, Title } from '@mantine/core';
import { EssayContent, ESSAY_SECTIONS } from '../../hooks/useEssayApi';
import { NodeListPreview, pruneNodes } from './NodeListPreview';

/**
 * Сданное (и любое доступное только на чтение) эссе — в том же виде, в каком
 * оно уедет в отчёт: нумерованными списками, а не полями ввода. Пустые разделы
 * не показываем, как и в экспорте.
 */
export const EssayPreview: React.FC<{ content: EssayContent }> = ({ content }) => {
  const { t } = useTranslation();
  const sections = ESSAY_SECTIONS.map((section) => ({
    section,
    nodes: pruneNodes(content[section]),
  })).filter(({ nodes }) => nodes.length > 0);

  if (sections.length === 0) {
    return (
      <Text c="dimmed" size="sm">
        {t('essays.emptySection')}
      </Text>
    );
  }

  return (
    <Stack gap="md">
      {sections.map(({ section, nodes }) => (
        <Card key={section} withBorder radius="md" padding="md">
          <Title order={4} mb="sm">
            {t(`essays.sections.${section}`)}
          </Title>
          <NodeListPreview nodes={nodes} />
        </Card>
      ))}
    </Stack>
  );
};
